module.exports = __webpack_public_path__ + "static/img/歡迎加入_300×300.fff45d7b.png";